import FormRow from 'components/FormRow';
import FormSection from 'components/FormSection';
import { InputWithField } from 'components/Input';
import { RadioGroupWithField } from 'components/RadioGroup';
import Condition from 'modules/ConditionalSubform/Condition';
import { fieldIsValid } from 'modules/Inquiry/Form/formConditions';
import {
  BFS_CUSTOMER_TYPE,
  BFS_CUSTOMER_TYPE__BUSINESS,
  BFS_CUSTOMER_TYPE__PRIVATE,
  PARTNER_SPECIFIC_IBAN,
  USER_PROFILE_FOUNDING_YEAR,
} from 'modules/Inquiry/Form/formFields';
import ProfileIndustry from 'modules/Inquiry/Form/Steps/UserProfile/ProfileIndustry';
import { fieldBusinessConditions } from 'schema/inquirySchema.conditions';
import { FormSections } from 'schema/inquirySchema.models';
import { useTranslations } from 'utils/hooks/useTranslations';

import AlreadyCustomer from './AlreadyCustomer/AlreadyCustomer';
import CompanyInformationForm from './CompanyInformationForm';
import { ExcludingQuestions } from './ExcludingQuestions';
import FoundingMonth from './FoundingMonth';
import FoundingYear from './FoundingYear';
import LegalForm from './LegalForm/LegalForm';
import TurnoverClass from './TurnoverClass/TurnoverClass';

const FIELDS = 'pages.userProfile.sections.completingCompanyDetails.fields';

export const BfsCompletingCompanyDetails: React.FC = () => {
  const t = useTranslations();

  return (
    <FormSection
      name={FormSections.companyDetails}
      sectionNumber={2}
      title={t('pages.userProfile.sections.completingCompanyDetails.title')}
    >
      {/* EBS-38: already-customer question moved to the top of the company section */}
      <FormRow>
        <AlreadyCustomer />
      </FormRow>

      {/* EBS-38: shown directly under the already-customer question, and only once the
          applicant has explicitly answered "no" (not while the question is unanswered). */}
      <Condition
        isBusinessCondition
        condition={fieldBusinessConditions.isNotAlreadyCompanyCustomerBfs}
      >
        <FormRow>
          <RadioGroupWithField
            name={BFS_CUSTOMER_TYPE}
            caption={t(`${FIELDS}.customerType.caption`)}
            options={[
              {
                value: BFS_CUSTOMER_TYPE__PRIVATE,
                caption: t(`${FIELDS}.customerType.options.private`),
              },
              {
                value: BFS_CUSTOMER_TYPE__BUSINESS,
                caption: t(`${FIELDS}.customerType.options.business`),
              },
            ]}
          />
        </FormRow>
      </Condition>

      <CompanyInformationForm />

      <FormRow>
        <InputWithField
          name={PARTNER_SPECIFIC_IBAN}
          optional
          type="tel"
          pattern="[0-9]*"
          numericOnly
          inputMaxLimit={10}
          separateThousands={false}
          caption={t(`${FIELDS}.bfsSozialbankAccountNumber.caption`)}
          placeholder={t(`${FIELDS}.bfsSozialbankAccountNumber.placeholder`)}
        />
      </FormRow>

      <FormRow>
        <LegalForm />
      </FormRow>

      <ProfileIndustry />

      <FormRow>
        <TurnoverClass />
      </FormRow>
      <FormRow>
        <FoundingYear />

        <Condition condition={fieldIsValid(USER_PROFILE_FOUNDING_YEAR)}>
          <FoundingMonth />
        </Condition>
      </FormRow>
      <ExcludingQuestions />
    </FormSection>
  );
};
